import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import ModalStore from '../../../Modal/Store';
import CloneStore from './Clone/Store';
import CollaboratorAccessStore from './CollaboratorAccess/Store';
import LearningCollectionListItemReady from './LearningCollectionListItemReady';
import LearningCollectionListItemRemove from './LearningCollectionListItemRemove';
import LearningCollectionStore from './Store';

interface Props {
  shareModalStore: ModalStore;
  hideModalStore: ModalStore;
  cloneStore: CloneStore;
  collaboratorAccessStore: CollaboratorAccessStore;
  learningCollectionStore: LearningCollectionStore;
  totalLength?: number;
}

function LearningCollectionListItemState({
  learningCollectionStore,
  hideModalStore,
  shareModalStore,
  cloneStore,
  collaboratorAccessStore,
  totalLength,
}: Props) {
  switch (learningCollectionStore.state.kind) {
    case 'waiting':
    case 'loading':
      return <></>;
    case 'error':
    case 'publishing':
    case 'ready':
      return (
        <LearningCollectionListItemReady
          shareModalStore={shareModalStore}
          hideModalStore={hideModalStore}
          cloneStore={cloneStore}
          collaboratorAccessStore={collaboratorAccessStore}
          learningCollectionStore={learningCollectionStore}
          learningCollectionSummaryResource={
            learningCollectionStore.state.learningCollectionSummaryResource
          }
          totalLength={totalLength}
        />
      );
    case 'hide':
      return (
        <LearningCollectionListItemRemove
          shareModalStore={shareModalStore}
          hideModalStore={hideModalStore}
          cloneStore={cloneStore}
          collaboratorAccessStore={collaboratorAccessStore}
          learningCollectionStore={learningCollectionStore}
          learningCollectionSummaryResource={
            learningCollectionStore.state.learningCollectionSummaryResource
          }
        />
      );
    default:
      assertNever(learningCollectionStore.state);
  }
}

export default observer(LearningCollectionListItemState);
